import React from 'react';

function Primary_Button({
    paddingProp,
    fontSizeProp,
    borderRadiusProp,
    widthProp,
    textProp,
    fontWeightProp,
    marginProp,
    cursorProp,
    bgColorProp,
    colorProp,
    borderProp,
    onClick
}) {
    return (
        <div
            className="primary_button_container"
            style={{
                backgroundColor: bgColorProp || '#004E89',
                padding: paddingProp || 'auto',
                borderRadius: borderRadiusProp || '10px',
                color: colorProp || 'white',
                fontSize: fontSizeProp || '14px',
                width: widthProp || 'auto',
                textAlign: 'center',
                fontWeight: fontWeightProp || 'auto',
                margin: marginProp || '0 auto',
                cursor: cursorProp || 'pointer',
                border: borderProp || 'none'
            }}
            onClick={onClick}
        >
            {textProp || 'Login'}
        </div>
    );
}

export default Primary_Button;
